import { TextPill } from 'components/FbUI/TextPill'
import { PillContainer } from 'components/FbUI/StagePill'
import { MULTI_VALUE_SELECT_COLORS } from 'utils/constants'
import { HOTEL_AMENITIES, HotelAmenityFields } from 'constants/hotelAmenities'

const { background, text } = MULTI_VALUE_SELECT_COLORS[0]

export function HotelAmenitiesChips({
  data,
}: {
  data?: HotelAmenityFields | null
}) {
  if (!data) return null
  const active = HOTEL_AMENITIES.filter((a) => data[a.key] === true)
  if (active.length === 0) return null

  return (
    <PillContainer data-testid="hotel-amenities-pill-container">
      {active.map((a) => (
        <TextPill key={a.key} textColor={text} backgroundColor={background}>
          {a.label}
        </TextPill>
      ))}
    </PillContainer>
  )
}
